import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchPackageDetail = createAction(ACTION.FETCH_PACKAGE_DETAIL.REQUEST, (id) => ({id}));
export const setPackage = createAction(ACTION.SET_PACKAGE);
export const clearState = createAction(ACTION.CLEAR_STATE);
